var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404ErrorRafikiIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.72 356.04H36.24C35.0285 356.04 33.8666 355.559 33.0099 354.702C32.1533 353.845 31.672 352.684 31.672 351.472V48.528C31.6825 47.3234 32.1685 46.1718 33.024 45.3238C33.8795 44.4757 35.0354 44 36.24 44H190.72C191.32 44 191.914 44.1182 192.468 44.3477C193.022 44.5773 193.526 44.9138 193.95 45.3379C194.374 45.7621 194.711 46.2657 194.94 46.8199C195.17 47.3741 195.288 47.9681 195.288 48.568V351.472C195.288 352.072 195.17 352.666 194.94 353.22C194.711 353.774 194.374 354.278 193.95 354.702C193.526 355.126 193.022 355.463 192.468 355.692C191.914 355.922 191.32 356.04 190.72 356.04ZM36.24 44.16C35.0822 44.1621 33.9724 44.623 33.1537 45.4417C32.335 46.2604 31.8741 47.3702 31.872 48.528V351.472C31.8741 352.63 32.335 353.74 33.1537 354.558C33.9724 355.377 35.0822 355.838 36.24 355.84H190.72C191.878 355.838 192.988 355.377 193.806 354.558C194.625 353.74 195.086 352.63 195.088 351.472V48.528C195.086 47.3702 194.625 46.2604 193.806 45.4417C192.988 44.623 191.878 44.1621 190.72 44.16H36.24Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M363.76 356.04H209.28C208.069 356.04 206.907 355.559 206.05 354.702C205.193 353.845 204.712 352.684 204.712 351.472V48.528C204.723 47.3234 205.209 46.1718 206.064 45.3238C206.92 44.4757 208.075 44 209.28 44H363.76C364.972 44 366.133 44.4813 366.99 45.3379C367.847 46.1946 368.328 47.3565 368.328 48.568V351.472C368.328 352.072 368.21 352.666 367.98 353.22C367.751 353.774 367.414 354.278 366.99 354.702C366.566 355.126 366.062 355.463 365.508 355.692C364.954 355.922 364.36 356.04 363.76 356.04ZM209.28 44.16C208.122 44.1621 207.012 44.623 206.194 45.4417C205.375 46.2604 204.914 47.3702 204.912 48.528V351.472C204.914 352.63 205.375 353.74 206.194 354.558C207.012 355.377 208.122 355.838 209.28 355.84H363.76C364.918 355.838 366.028 355.377 366.846 354.558C367.665 353.74 368.126 352.63 368.128 351.472V48.528C368.126 47.3702 367.665 46.2604 366.846 45.4417C366.028 44.623 364.918 44.1621 363.76 44.16H209.28Z",
    fill: "#EBEBEB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.44 134.6L91.736 137.216L94.632 137.64L92.536 139.68L93.032 142.56L90.44 141.2L87.856 142.56L88.352 139.68L86.256 137.64L89.152 137.216L90.44 134.6Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M349.36 257.984L350.656 260.608L353.552 261.032L351.456 263.064L351.952 265.952L349.36 264.592L346.776 265.952L347.272 263.064L345.176 261.032L348.072 260.608L349.36 257.984Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M298.08 334.056L299.376 336.672L302.264 337.096L300.168 339.136L300.664 342.016L298.08 340.656L295.496 342.016L295.984 339.136L293.896 337.096L296.784 336.672L298.08 334.056Z",
    fill: "#F5F5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M180.752 88.12L181.232 89.096L182.312 89.256C182.372 89.2639 182.429 89.2887 182.476 89.3277C182.522 89.3667 182.557 89.4182 182.575 89.4761C182.594 89.534 182.595 89.5959 182.58 89.6547C182.565 89.7135 182.533 89.7667 182.488 89.808L181.688 90.568L181.872 91.64C181.881 91.6996 181.874 91.7608 181.851 91.8166C181.828 91.8724 181.79 91.9208 181.741 91.9564C181.692 91.9919 181.635 92.0133 181.575 92.0182C181.514 92.0231 181.454 92.0112 181.4 91.984L180.44 91.472L179.48 91.984C179.426 92.0112 179.366 92.0231 179.306 92.0182C179.245 92.0133 179.188 91.9919 179.139 91.9564C179.09 91.9208 179.052 91.8724 179.029 91.8166C179.006 91.7608 178.999 91.6996 179.008 91.64L179.184 90.568L178.384 89.808C178.339 89.7661 178.307 89.7123 178.292 89.6529C178.277 89.5935 178.28 89.5311 178.299 89.4729C178.318 89.4148 178.354 89.3634 178.402 89.325C178.449 89.2865 178.507 89.2626 178.568 89.256L179.64 89.096L180.12 88.12C180.139 88.0509 180.181 87.9901 180.238 87.9467C180.295 87.9034 180.364 87.8799 180.436 87.8799C180.508 87.8799 180.577 87.9034 180.634 87.9467C180.692 87.9901 180.733 88.0509 180.752 88.12Z",
    fill: "#EBEBEB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.624 321.6L49.104 322.568L50.176 322.728C50.2369 322.736 50.2941 322.762 50.3413 322.801C50.3885 322.84 50.4237 322.892 50.4429 322.95C50.462 323.009 50.4644 323.071 50.4498 323.131C50.4351 323.191 50.404 323.245 50.36 323.288L49.56 324.04L49.744 325.112C49.7535 325.172 49.7462 325.233 49.7232 325.288C49.7001 325.344 49.6621 325.393 49.6132 325.428C49.5644 325.464 49.5067 325.485 49.4465 325.49C49.3863 325.495 49.3259 325.483 49.272 325.456L48.312 324.952L47.352 325.456C47.2981 325.483 47.2377 325.495 47.1775 325.49C47.1173 325.485 47.0596 325.464 47.0108 325.428C46.962 325.393 46.9239 325.344 46.9008 325.288C46.8778 325.233 46.8706 325.172 46.88 325.112L47.064 324.04L46.264 323.288C46.2201 323.246 46.1889 323.192 46.1739 323.133C46.1588 323.074 46.1605 323.012 46.1788 322.953C46.1971 322.895 46.2312 322.843 46.2773 322.803C46.3235 322.764 46.3798 322.737 46.44 322.728L47.512 322.568L48 321.6C48.0214 321.534 48.0631 321.476 48.1191 321.436C48.1752 321.395 48.2427 321.373 48.312 321.373C48.3813 321.373 48.4488 321.395 48.5049 321.436C48.5609 321.476 48.6026 321.534 48.624 321.6Z",
    fill: "#F5F5F5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2 77.8399L70.68 78.8159L71.76 78.9679C71.8202 78.9775 71.8766 79.0037 71.9227 79.0436C71.9689 79.0834 72.003 79.1353 72.0213 79.1935C72.0395 79.2516 72.0412 79.3137 72.0262 79.3728C72.0111 79.4319 71.9799 79.4856 71.936 79.5279L71.136 80.3279L71.32 81.3919C71.3328 81.4523 71.3279 81.5151 71.3058 81.5728C71.2837 81.6304 71.2453 81.6804 71.1954 81.7168C71.1456 81.7532 71.0862 81.7743 71.0246 81.7777C70.9629 81.7811 70.9016 81.7666 70.848 81.7359L69.888 81.2319L68.928 81.7359C68.8745 81.7666 68.8131 81.7811 68.7515 81.7777C68.6899 81.7743 68.6305 81.7532 68.5806 81.7168C68.5307 81.6804 68.4924 81.6304 68.4703 81.5728C68.4482 81.5151 68.4433 81.4523 68.456 81.3919L68.632 80.3279L67.832 79.5279C67.788 79.4851 67.7569 79.4307 67.7423 79.3711C67.7276 79.3114 67.73 79.2488 67.7492 79.1905C67.7684 79.1321 67.8035 79.0803 67.8507 79.041C67.8979 79.0016 67.9552 78.9763 68.016 78.9679L69.088 78.8159L69.6 77.8399C69.6257 77.7818 69.6678 77.7324 69.721 77.6977C69.7743 77.663 69.8365 77.6445 69.9 77.6445C69.9636 77.6445 70.0258 77.663 70.079 77.6977C70.1323 77.7324 70.1743 77.7818 70.2 77.8399Z",
    fill: "#EBEBEB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.904 270.656C68.9056 270.866 68.8445 271.073 68.7286 271.249C68.6126 271.425 68.447 271.563 68.2527 271.644C68.0584 271.726 67.8443 271.748 67.6373 271.708C67.4304 271.668 67.2401 271.567 67.0905 271.419C66.9409 271.27 66.8387 271.081 66.797 270.874C66.7553 270.668 66.7759 270.453 66.8562 270.258C66.9365 270.063 67.0729 269.897 67.248 269.779C67.4232 269.662 67.6292 269.6 67.84 269.6C68.1208 269.6 68.3902 269.711 68.5895 269.908C68.7888 270.106 68.9019 270.375 68.904 270.656Z",
    fill: "#EBEBEB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M220.536 137.512C220.538 137.723 220.477 137.929 220.361 138.105C220.245 138.281 220.079 138.419 219.885 138.501C219.691 138.583 219.476 138.605 219.269 138.565C219.062 138.524 218.872 138.424 218.723 138.275C218.573 138.127 218.471 137.937 218.429 137.731C218.387 137.524 218.408 137.31 218.488 137.115C218.569 136.92 218.705 136.753 218.88 136.636C219.055 136.519 219.261 136.456 219.472 136.456C219.611 136.455 219.75 136.482 219.879 136.534C220.008 136.587 220.125 136.664 220.224 136.763C220.323 136.861 220.401 136.977 220.455 137.106C220.508 137.235 220.536 137.373 220.536 137.512Z",
    fill: "#EBEBEB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M165.368 78.7203C165.368 78.9307 165.306 79.1364 165.189 79.3114C165.072 79.4864 164.906 79.6227 164.711 79.7033C164.517 79.7838 164.303 79.8049 164.096 79.7638C163.89 79.7228 163.7 79.6214 163.552 79.4726C163.403 79.3238 163.301 79.1342 163.26 78.9278C163.219 78.7214 163.24 78.5075 163.321 78.3131C163.402 78.1187 163.538 77.9525 163.713 77.8356C163.888 77.7187 164.094 77.6562 164.304 77.6562C164.586 77.6583 164.855 77.7711 165.054 77.9702C165.253 78.1693 165.366 78.4387 165.368 78.7203Z",
    fill: "#F5F5F5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.053 338.035C170.214 337.289 172.171 334.122 171.425 330.962C170.679 327.801 167.512 325.844 164.352 326.59C161.191 327.336 159.234 330.503 159.979 333.663C160.725 336.824 163.892 338.781 167.053 338.035Z",
    fill: "#F0F0F0"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M163.68 328.872C162.475 328.87 161.301 329.251 160.328 329.96C159.831 331.101 159.709 332.37 159.979 333.584C160.25 334.798 160.899 335.895 161.834 336.717C162.768 337.538 163.94 338.042 165.179 338.154C166.418 338.267 167.661 337.983 168.728 337.344C169.2 336.47 169.438 335.489 169.417 334.495C169.396 333.502 169.117 332.531 168.609 331.678C168.1 330.825 167.378 330.118 166.514 329.628C165.65 329.137 164.673 328.88 163.68 328.88V328.872Z",
    fill: "#E6E6E6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.144 230.112H69.464V208.136L118.144 150.264H141.44V209.384H153.512V230.112H141.44V248.096H118.144V230.112ZM118.144 209.384V179.112L92.416 209.384H118.144Z",
    fill: "url(#paint0_linear_300_160)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M161.84 199.608C161.84 181.32 165.131 168.52 171.712 161.208C178.293 153.896 188.323 150.243 201.8 150.248C208.269 150.248 213.584 151.048 217.744 152.648C221.523 154.01 224.983 156.131 227.912 158.88C230.38 161.237 232.472 163.959 234.112 166.952C235.735 170.077 236.958 173.394 237.752 176.824C239.561 184.153 240.463 191.676 240.44 199.224C240.44 216.675 237.488 229.445 231.584 237.536C225.68 245.627 215.512 249.675 201.08 249.68C192.984 249.68 186.443 248.389 181.456 245.808C176.429 243.185 172.195 239.266 169.192 234.456C166.872 230.915 165.067 226.069 163.776 219.92C162.436 213.234 161.787 206.427 161.84 199.608ZM188.352 199.672C188.352 211.939 189.432 220.304 191.592 224.768C193.752 229.232 196.891 231.475 201.008 231.496C202.315 231.511 203.611 231.266 204.822 230.775C206.034 230.285 207.135 229.559 208.064 228.64C210.059 226.736 211.525 223.728 212.464 219.616C213.403 215.504 213.872 209.104 213.872 200.416C213.872 187.648 212.789 179.064 210.624 174.664C208.459 170.264 205.211 168.067 200.88 168.072C196.464 168.072 193.264 170.315 191.28 174.8C189.296 179.285 188.32 187.576 188.352 199.672Z",
    fill: "url(#paint1_linear_300_160)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M297.392 230.112H248.712V208.136L297.392 150.264H320.688V209.384H332.8V230.112H320.688V248.096H297.392V230.112ZM297.392 209.384V179.112L271.672 209.384H297.392Z",
    fill: "url(#paint2_linear_300_160)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M160.8 116.496C160.8 116.792 160.712 117.082 160.547 117.328C160.383 117.574 160.148 117.766 159.875 117.879C159.601 117.992 159.3 118.021 159.009 117.963C158.719 117.904 158.452 117.761 158.243 117.551C158.034 117.341 157.893 117.074 157.836 116.783C157.779 116.492 157.81 116.191 157.924 115.918C158.039 115.645 158.232 115.412 158.479 115.248C158.726 115.085 159.016 114.998 159.312 115C159.508 115 159.702 115.039 159.883 115.114C160.064 115.189 160.229 115.3 160.367 115.439C160.505 115.578 160.615 115.743 160.689 115.924C160.763 116.106 160.801 116.3 160.8 116.496Z",
    fill: "url(#paint3_linear_300_160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3759 173.96C58.9592 173.96 59.4319 173.487 59.4319 172.904C59.4319 172.32 58.9592 171.848 58.3759 171.848C57.7927 171.848 57.3199 172.32 57.3199 172.904C57.3199 173.487 57.7927 173.96 58.3759 173.96Z",
    fill: "url(#paint4_linear_300_160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.84 328.175C233.675 328.175 234.352 327.498 234.352 326.663C234.352 325.828 233.675 325.151 232.84 325.151C232.005 325.151 231.328 325.828 231.328 326.663C231.328 327.498 232.005 328.175 232.84 328.175Z",
    fill: "url(#paint5_linear_300_160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.2 266.656C269.783 266.656 270.256 266.183 270.256 265.6C270.256 265.017 269.783 264.544 269.2 264.544C268.617 264.544 268.144 265.017 268.144 265.6C268.144 266.183 268.617 266.656 269.2 266.656Z",
    fill: "url(#paint6_linear_300_160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.336 76.4955C339.336 76.7043 339.274 76.9085 339.158 77.0821C339.042 77.2558 338.877 77.3911 338.684 77.4711C338.491 77.551 338.279 77.5719 338.074 77.5312C337.869 77.4904 337.681 77.3898 337.533 77.2422C337.385 77.0945 337.285 76.9063 337.244 76.7015C337.203 76.4966 337.224 76.2843 337.304 76.0913C337.384 75.8984 337.52 75.7335 337.693 75.6174C337.867 75.5014 338.071 75.4395 338.28 75.4395C338.56 75.4395 338.829 75.5507 339.027 75.7487C339.225 75.9468 339.336 76.2154 339.336 76.4955Z",
    fill: "url(#paint7_linear_300_160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.2 55.1996C138.2 55.4084 138.138 55.6126 138.022 55.7862C137.906 55.9599 137.741 56.0952 137.548 56.1752C137.355 56.2551 137.143 56.276 136.938 56.2353C136.733 56.1945 136.545 56.0939 136.397 55.9463C136.249 55.7986 136.149 55.6104 136.108 55.4056C136.067 55.2007 136.088 54.9884 136.168 54.7954C136.248 54.6025 136.384 54.4376 136.557 54.3215C136.731 54.2055 136.935 54.1436 137.144 54.1436C137.423 54.1456 137.691 54.2576 137.888 54.4552C138.086 54.6528 138.198 54.9201 138.2 55.1996Z",
    fill: "url(#paint8_linear_300_160)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.16 110.607C222.743 110.607 223.216 110.134 223.216 109.551C223.216 108.968 222.743 108.495 222.16 108.495C221.577 108.495 221.104 108.968 221.104 109.551C221.104 110.134 221.577 110.607 222.16 110.607Z",
    fill: "url(#paint9_linear_300_160)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M112.984 110.616C122.664 110.616 130.512 102.768 130.512 93.0876C130.512 83.4071 122.664 75.5596 112.984 75.5596C103.303 75.5596 95.4559 83.4071 95.4559 93.0876C95.4559 102.768 103.303 110.616 112.984 110.616Z",
    fill: "url(#paint10_linear_300_160)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M112.984 110.616C122.664 110.616 130.512 102.768 130.512 93.0876C130.512 83.4071 122.664 75.5596 112.984 75.5596C103.303 75.5596 95.4559 83.4071 95.4559 93.0876C95.4559 102.768 103.303 110.616 112.984 110.616Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.944 79.8634C104.557 79.856 102.194 80.338 99.9999 81.2794C97.3039 84.2425 95.7037 88.0394 95.4656 92.0383C95.2275 96.0373 96.3657 99.9973 98.691 103.259C101.016 106.522 104.388 108.889 108.246 109.968C112.104 111.048 116.215 110.773 119.896 109.191C122.178 106.677 123.68 103.554 124.221 100.201C124.762 96.849 124.319 93.4117 122.944 90.3068C121.569 87.202 119.322 84.5631 116.476 82.7107C113.63 80.8582 110.308 79.8718 106.912 79.8714L106.944 79.8634Z",
    fill: "url(#paint11_linear_300_160)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M105.2 84.4955C105.2 84.812 105.106 85.1213 104.93 85.3844C104.755 85.6475 104.505 85.8526 104.212 85.9737C103.92 86.0948 103.598 86.1265 103.288 86.0648C102.977 86.003 102.692 85.8506 102.469 85.6269C102.245 85.4031 102.092 85.118 102.031 84.8076C101.969 84.4973 102.001 84.1756 102.122 83.8832C102.243 83.5908 102.448 83.341 102.711 83.1652C102.974 82.9893 103.284 82.8955 103.6 82.8955C104.024 82.8955 104.431 83.0641 104.731 83.3641C105.031 83.6642 105.2 84.0712 105.2 84.4955Z",
    fill: "url(#paint12_linear_300_160)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M124.048 82.8959C124.048 83.2123 123.954 83.5217 123.778 83.7848C123.602 84.0479 123.353 84.253 123.06 84.3741C122.768 84.4952 122.446 84.5269 122.136 84.4652C121.825 84.4034 121.54 84.251 121.317 84.0273C121.093 83.8035 120.94 83.5184 120.879 83.208C120.817 82.8977 120.849 82.576 120.97 82.2836C121.091 81.9912 121.296 81.7414 121.559 81.5655C121.822 81.3897 122.131 81.2959 122.448 81.2959C122.872 81.2959 123.279 81.4645 123.579 81.7645C123.879 82.0646 124.048 82.4716 124.048 82.8959Z",
    fill: "url(#paint13_linear_300_160)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M120.848 94.3193C120.848 94.8383 120.694 95.3456 120.406 95.7771C120.117 96.2086 119.708 96.545 119.228 96.7436C118.749 96.9422 118.221 96.9941 117.712 96.8929C117.203 96.7916 116.736 96.5417 116.369 96.1748C116.002 95.8078 115.752 95.3402 115.65 94.8312C115.549 94.3222 115.601 93.7946 115.8 93.3151C115.998 92.8357 116.335 92.4259 116.766 92.1375C117.198 91.8492 117.705 91.6953 118.224 91.6953C118.92 91.6953 119.587 91.9718 120.079 92.4639C120.572 92.956 120.848 93.6234 120.848 94.3193Z",
    fill: "url(#paint14_linear_300_160)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M112.512 101.8C112.512 102.493 112.306 103.17 111.921 103.747C111.536 104.323 110.989 104.772 110.349 105.037C109.709 105.302 109.004 105.372 108.324 105.237C107.645 105.101 107.02 104.768 106.53 104.278C106.04 103.788 105.706 103.163 105.571 102.483C105.436 101.804 105.505 101.099 105.771 100.459C106.036 99.8187 106.485 99.2715 107.061 98.8864C107.637 98.5014 108.315 98.2959 109.008 98.2959C109.937 98.2959 110.828 98.6651 111.486 99.3222C112.143 99.9793 112.512 100.871 112.512 101.8Z",
    fill: "url(#paint15_linear_300_160)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M320.72 304.516C322.671 296.247 317.55 287.961 309.281 286.01C301.012 284.058 292.726 289.179 290.774 297.448C288.823 305.717 293.944 314.003 302.213 315.955C310.482 317.906 318.768 312.785 320.72 304.516Z",
    fill: "url(#paint16_linear_300_160)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M320.72 304.516C322.671 296.247 317.55 287.961 309.281 286.01C301.012 284.058 292.726 289.179 290.774 297.448C288.823 305.717 293.944 314.003 302.213 315.955C310.482 317.906 318.768 312.785 320.72 304.516Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M315.464 289.072C312.054 288.043 308.392 288.229 305.104 289.6C301.816 290.971 299.106 293.441 297.437 296.588C295.768 299.735 295.244 303.364 295.953 306.855C296.663 310.346 298.563 313.482 301.328 315.728C302.762 316.164 304.253 316.385 305.752 316.384C308.928 316.383 312.026 315.4 314.62 313.568C317.215 311.736 319.179 309.147 320.243 306.154C321.307 303.162 321.419 299.913 320.564 296.855C319.708 293.796 317.926 291.078 315.464 289.072Z",
    fill: "url(#paint17_linear_300_160)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M291.064 305.599C274.64 313.327 286.888 319.287 310.032 310.967C331.464 303.263 339.632 293.551 320.432 296.567C321.464 300.607 294.624 311.063 291.064 305.599Z",
    fill: "url(#paint18_linear_300_160)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M315.28 150.264C293.768 164.8 265.92 184 258.232 230.112H256.592C264.072 184.512 290.904 164.856 312.424 150.264H315.28Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M204 294.616C190.4 294.616 176.952 288.48 170.4 278.464C166.36 272.272 161.664 259.304 175.648 242L176.888 243.008C167 255.248 165.176 267.528 171.744 277.592C179.744 289.832 198.616 295.992 214.728 291.608C231.232 287.12 241.248 272.768 242.216 252.232C245.52 181.984 282.84 160.344 310.088 144.544C327.024 134.728 339.256 127.64 336.568 112.672C336.192 110.6 335.368 109.168 334.032 108.288C330.552 105.992 323.752 107.584 315.88 109.416C300.432 113.016 279.28 117.944 266.68 96.5119L268.064 95.7119C280.064 116.136 299.72 111.552 315.52 107.872C323.752 105.96 330.856 104.304 334.912 106.968C336.632 108.096 337.688 109.88 338.112 112.408C341 128.472 327.712 136.184 310.872 145.944C283.936 161.56 247.056 182.944 243.792 252.344C242.784 273.624 232.336 288.512 215.12 293.192C211.493 294.158 207.753 294.637 204 294.616Z",
    fill: "url(#paint19_linear_300_160)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M204 294.616C190.4 294.616 176.952 288.48 170.4 278.464C166.36 272.272 161.664 259.304 175.648 242L176.888 243.008C167 255.248 165.176 267.528 171.744 277.592C179.744 289.832 198.616 295.992 214.728 291.608C231.232 287.12 241.248 272.768 242.216 252.232C245.52 181.984 282.84 160.344 310.088 144.544C327.024 134.728 339.256 127.64 336.568 112.672C336.192 110.6 335.368 109.168 334.032 108.288C330.552 105.992 323.752 107.584 315.88 109.416C300.432 113.016 279.28 117.944 266.68 96.5119L268.064 95.7119C280.064 116.136 299.72 111.552 315.52 107.872C323.752 105.96 330.856 104.304 334.912 106.968C336.632 108.096 337.688 109.88 338.112 112.408C341 128.472 327.712 136.184 310.872 145.944C283.936 161.56 247.056 182.944 243.792 252.344C242.784 273.624 232.336 288.512 215.12 293.192C211.493 294.158 207.753 294.637 204 294.616Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M250.208 77.5996C253.894 77.6209 257.556 78.1953 261.072 79.3036C261.072 79.3036 269.872 94.3196 270.912 97.7596C270.544 101.152 264.824 106.712 264.824 106.712L250.208 77.5996Z",
    fill: "url(#paint20_linear_300_160)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M250.208 77.5996C253.894 77.6209 257.556 78.1953 261.072 79.3036C261.072 79.3036 269.872 94.3196 270.912 97.7596C270.544 101.152 264.824 106.712 264.824 106.712L250.208 77.5996Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M276.272 150.504C272.883 146.36 269.793 141.981 267.024 137.4C266.352 136.242 265.715 135.064 265.112 133.864C264.768 133.184 264.44 132.504 264.12 131.816C263.7 131.146 263.374 130.422 263.152 129.664C262.192 119.528 265.664 112.064 262.352 103.928L249.168 109.08C249.168 109.08 250.288 123.576 252.848 132.28C254.448 137.664 258.032 142.32 261.496 146.632C262.576 147.976 263.616 149.36 264.696 150.712C265.776 152.064 266.864 153.16 267.896 154.432C269.456 156.36 269.968 158.208 268.792 160.48L268.592 160.84C268.256 161.432 269.824 162.104 270.816 160.84C272.416 158.776 272.192 158.904 273.584 157.144C274.432 156.08 275.4 154.92 276.24 153.944C276.645 153.464 276.87 152.858 276.876 152.23C276.882 151.601 276.668 150.991 276.272 150.504Z",
    fill: "url(#paint21_linear_300_160)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M276.272 150.504C272.883 146.36 269.793 141.981 267.024 137.4C266.352 136.242 265.715 135.064 265.112 133.864C264.768 133.184 264.44 132.504 264.12 131.816C263.7 131.146 263.374 130.422 263.152 129.664C262.192 119.528 265.664 112.064 262.352 103.928L249.168 109.08C249.168 109.08 250.288 123.576 252.848 132.28C254.448 137.664 258.032 142.32 261.496 146.632C262.576 147.976 263.616 149.36 264.696 150.712C265.776 152.064 266.864 153.16 267.896 154.432C269.456 156.36 269.968 158.208 268.792 160.48L268.592 160.84C268.256 161.432 269.824 162.104 270.816 160.84C272.416 158.776 272.192 158.904 273.584 157.144C274.432 156.08 275.4 154.92 276.24 153.944C276.645 153.464 276.87 152.858 276.876 152.23C276.882 151.601 276.668 150.991 276.272 150.504Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M273.048 146.336C270.956 148.579 268.634 150.595 266.12 152.352C266.464 152.736 266.8 153.152 267.144 153.52C269.661 151.82 271.947 149.8 273.944 147.512L273.048 146.336Z",
    fill: "url(#paint22_linear_300_160)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M276.272 150.504L276.176 150.392C275.56 151.098 275.202 151.992 275.16 152.928C275.109 153.57 275.213 154.215 275.464 154.808L276.224 153.904C276.621 153.429 276.843 152.831 276.852 152.212C276.86 151.593 276.656 150.99 276.272 150.504Z",
    fill: "url(#paint23_linear_300_160)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M247.072 87.1993C245.643 89.3393 243.928 91.2745 241.976 92.9513C240.893 93.8843 239.707 94.6896 238.44 95.3513C237.774 95.6923 237.084 95.9838 236.376 96.2233L235.832 96.3993L235.656 96.4473L235.28 96.5513C235.048 96.6062 234.813 96.6436 234.576 96.6633C233.901 96.7149 233.222 96.6527 232.568 96.4793C231.743 96.2451 230.952 95.9035 230.216 95.4633C229.624 95.117 229.05 94.7405 228.496 94.3353C227.496 93.5913 226.539 92.7899 225.632 91.9353C223.882 90.2772 222.276 88.4734 220.832 86.5433C220.554 86.1672 220.416 85.7059 220.441 85.239C220.467 84.772 220.655 84.3286 220.973 83.9853C221.29 83.6421 221.718 83.4205 222.181 83.3587C222.645 83.297 223.116 83.3991 223.512 83.6473H223.576C225.464 84.8473 227.368 86.1113 229.224 87.2393C230.168 87.7913 231.08 88.3513 231.984 88.7833C232.397 88.9993 232.821 89.1916 233.256 89.3593C233.527 89.4788 233.817 89.5492 234.112 89.5673C234.16 89.5673 234.112 89.5113 233.816 89.5193C233.723 89.5137 233.629 89.5137 233.536 89.5193L233.36 89.5593L233.624 89.4233C233.979 89.232 234.324 89.021 234.656 88.7913C235.372 88.2865 236.041 87.719 236.656 87.0953C238.054 85.6306 239.363 84.0838 240.576 82.4633C241.241 81.7195 242.16 81.251 243.152 81.1496C244.144 81.0483 245.139 81.3214 245.94 81.9155C246.742 82.5095 247.292 83.3816 247.484 84.3606C247.675 85.3396 247.494 86.3549 246.976 87.2073L247.072 87.1993Z",
    fill: "url(#paint24_linear_300_160)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M247.072 87.1993C245.643 89.3393 243.928 91.2745 241.976 92.9513C240.893 93.8843 239.707 94.6896 238.44 95.3513C237.774 95.6923 237.084 95.9838 236.376 96.2233L235.832 96.3993L235.656 96.4473L235.28 96.5513C235.048 96.6062 234.813 96.6436 234.576 96.6633C233.901 96.7149 233.222 96.6527 232.568 96.4793C231.743 96.2451 230.952 95.9035 230.216 95.4633C229.624 95.117 229.05 94.7405 228.496 94.3353C227.496 93.5913 226.539 92.7899 225.632 91.9353C223.882 90.2772 222.276 88.4734 220.832 86.5433C220.554 86.1672 220.416 85.7059 220.441 85.239C220.467 84.772 220.655 84.3286 220.973 83.9853C221.29 83.6421 221.718 83.4205 222.181 83.3587C222.645 83.297 223.116 83.3991 223.512 83.6473H223.576C225.464 84.8473 227.368 86.1113 229.224 87.2393C230.168 87.7913 231.08 88.3513 231.984 88.7833C232.397 88.9993 232.821 89.1916 233.256 89.3593C233.527 89.4788 233.817 89.5492 234.112 89.5673C234.16 89.5673 234.112 89.5113 233.816 89.5193C233.723 89.5137 233.629 89.5137 233.536 89.5193L233.36 89.5593L233.624 89.4233C233.979 89.232 234.324 89.021 234.656 88.7913C235.372 88.2865 236.041 87.719 236.656 87.0953C238.054 85.6306 239.363 84.0838 240.576 82.4633C241.241 81.7195 242.16 81.251 243.152 81.1496C244.144 81.0483 245.139 81.3214 245.94 81.9155C246.742 82.5095 247.292 83.3816 247.484 84.3606C247.675 85.3396 247.494 86.3549 246.976 87.2073L247.072 87.1993Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M217.832 81.9359L218.768 83.5359C218.768 83.5359 219.48 85.6319 220.912 86.0159L224.8 84.7599L224.6 84.4319C224.104 83.6799 224.16 82.2159 224.328 80.9999C224.496 79.7839 223.872 79.7439 223.408 80.0479C223.079 80.4261 222.848 80.8794 222.736 81.3679C222.545 81.1037 222.334 80.8549 222.104 80.6239L220.92 79.4399C220.672 79.1971 220.341 79.0572 219.993 79.0483C219.646 79.0394 219.309 79.1621 219.048 79.3919L218.088 80.2479C217.86 80.4585 217.711 80.7403 217.664 81.047C217.618 81.3537 217.677 81.6672 217.832 81.9359Z",
    fill: "url(#paint25_linear_300_160)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M217.832 81.9359L218.768 83.5359C218.768 83.5359 219.48 85.6319 220.912 86.0159L224.8 84.7599L224.6 84.4319C224.104 83.6799 224.16 82.2159 224.328 80.9999C224.496 79.7839 223.872 79.7439 223.408 80.0479C223.079 80.4261 222.848 80.8794 222.736 81.3679C222.545 81.1037 222.334 80.8549 222.104 80.6239L220.92 79.4399C220.672 79.1971 220.341 79.0572 219.993 79.0483C219.646 79.0394 219.309 79.1621 219.048 79.3919L218.088 80.2479C217.86 80.4585 217.711 80.7403 217.664 81.047C217.618 81.3537 217.677 81.6672 217.832 81.9359Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M254.136 76.1758C249.824 77.3189 245.693 79.0612 241.864 81.3518C241.267 81.7256 240.798 82.273 240.521 82.9208C240.243 83.5685 240.17 84.2855 240.312 84.9758C241.856 92.5278 245.368 102.64 249.16 109.08L266.848 101.76C266.968 98.6398 262.672 88.5438 258.296 78.7838C257.512 77.0318 256 75.7278 254.136 76.1758Z",
    fill: "url(#paint26_linear_300_160)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M254.136 76.1758C249.824 77.3189 245.693 79.0612 241.864 81.3518C241.267 81.7256 240.798 82.273 240.521 82.9208C240.243 83.5685 240.17 84.2855 240.312 84.9758C241.856 92.5278 245.368 102.64 249.16 109.08L266.848 101.76C266.968 98.6398 262.672 88.5438 258.296 78.7838C257.512 77.0318 256 75.7278 254.136 76.1758Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M261.04 84.968L257.528 83.792C258.328 85.848 261.152 88.448 263.128 89.976C262.488 88.376 261.776 86.696 261.04 84.968Z",
    fill: "url(#paint27_linear_300_160)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M252.976 68.2557C251.512 65.4717 248.352 64.0717 244.56 64.3837C241.36 64.6557 238.528 67.9197 238.864 69.6797C239.2 71.4397 241.888 72.1917 242.4 72.7997L240.184 74.3997C239.922 74.5892 239.7 74.8298 239.533 75.1071C239.366 75.3844 239.257 75.6927 239.212 76.0133C239.167 76.3339 239.188 76.6603 239.272 76.9728C239.357 77.2853 239.504 77.5775 239.704 77.8317C240.64 79.0157 241.872 80.2317 242.584 81.1277C248.712 80.9677 253.248 78.6317 254.888 76.3837C254.272 73.5357 254.4 71.0237 252.976 68.2557Z",
    fill: "url(#paint28_linear_300_160)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M252.976 68.2557C251.512 65.4717 248.352 64.0717 244.56 64.3837C241.36 64.6557 238.528 67.9197 238.864 69.6797C239.2 71.4397 241.888 72.1917 242.4 72.7997L240.184 74.3997C239.922 74.5892 239.7 74.8298 239.533 75.1071C239.366 75.3844 239.257 75.6927 239.212 76.0133C239.167 76.3339 239.188 76.6603 239.272 76.9728C239.357 77.2853 239.504 77.5775 239.704 77.8317C240.64 79.0157 241.872 80.2317 242.584 81.1277C248.712 80.9677 253.248 78.6317 254.888 76.3837C254.272 73.5357 254.4 71.0237 252.976 68.2557Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M249.968 69.9835C250.403 71.0992 250.498 72.3188 250.24 73.4882C249.982 74.6576 249.383 75.7242 248.519 76.5533C247.655 77.3824 246.564 77.9367 245.385 78.1462C244.206 78.3556 242.991 78.2108 241.895 77.7301C240.798 77.2493 239.868 76.4542 239.223 75.4453C238.578 74.4363 238.247 73.2587 238.271 72.0615C238.295 70.8642 238.674 69.701 239.359 68.7188C240.044 67.7367 241.005 66.9797 242.12 66.5435C243.617 65.9603 245.284 65.995 246.756 66.64C248.227 67.285 249.382 68.4875 249.968 69.9835Z",
    fill: "#263238"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M301.912 142.08C301.824 139.448 301.704 139.68 301.632 137.464C301.584 136.104 301.576 134.592 301.568 133.288C301.565 132.669 301.349 132.069 300.955 131.591C300.562 131.113 300.015 130.785 299.408 130.664C298.352 130.448 297.288 130.248 296.208 130.024C294.824 129.728 293.456 129.408 292.104 129.016C291.048 128.712 290.008 128.376 288.976 128C287.944 127.624 286.784 127.2 285.712 126.704C284.448 126.168 283.2 125.592 281.968 124.992C280.584 124.336 279.216 123.648 277.848 122.952C272.584 114.24 272.472 108.496 266.824 101.76L254.696 107.248C254.696 107.248 263.608 123.056 269.672 129.76C273.168 133.616 278.648 135.36 283.536 136.624C287.064 137.528 290.64 138.224 294.216 138.888C295.608 139.144 297.12 139.24 298.32 140.072C299.208 140.752 299.817 141.734 300.032 142.832C300.085 143.056 300.133 143.28 300.176 143.504C300.328 144.176 301.968 143.664 301.912 142.08Z",
    fill: "url(#paint29_linear_300_160)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M301.912 142.08C301.824 139.448 301.704 139.68 301.632 137.464C301.584 136.104 301.576 134.592 301.568 133.288C301.565 132.669 301.349 132.069 300.955 131.591C300.562 131.113 300.015 130.785 299.408 130.664C298.352 130.448 297.288 130.248 296.208 130.024C294.824 129.728 293.456 129.408 292.104 129.016C291.048 128.712 290.008 128.376 288.976 128C287.944 127.624 286.784 127.2 285.712 126.704C284.448 126.168 283.2 125.592 281.968 124.992C280.584 124.336 279.216 123.648 277.848 122.952C272.584 114.24 272.472 108.496 266.824 101.76L254.696 107.248C254.696 107.248 263.608 123.056 269.672 129.76C273.168 133.616 278.648 135.36 283.536 136.624C287.064 137.528 290.64 138.224 294.216 138.888C295.608 139.144 297.12 139.24 298.32 140.072C299.208 140.752 299.817 141.734 300.032 142.832C300.085 143.056 300.133 143.28 300.176 143.504C300.328 144.176 301.968 143.664 301.912 142.08Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M295.76 129.92C295.28 129.816 294.8 129.712 294.312 129.592C294.352 132.36 293.056 137.128 292.584 138.576L294.104 138.864C295.1 135.982 295.658 132.967 295.76 129.92Z",
    fill: "url(#paint30_linear_300_160)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M301.6 133.288C301.598 132.67 301.382 132.071 300.991 131.593C300.599 131.115 300.054 130.787 299.448 130.664L298.648 130.512C298.777 131.421 299.242 132.249 299.952 132.832C300.409 133.254 300.956 133.566 301.552 133.744C301.6 133.6 301.6 133.44 301.6 133.288Z",
    fill: "url(#paint31_linear_300_160)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M248.84 70.0317C249.16 71.2477 247.8 72.5197 246.72 71.4717C245.712 70.3909 244.609 69.4029 243.424 68.5197C242.312 67.8237 243.792 66.6077 245.544 67.0797C246.292 67.2675 246.982 67.6344 247.557 68.1487C248.131 68.6629 248.571 69.3092 248.84 70.0317Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M248.928 108.687C248.368 108.895 249.392 109.855 249.392 109.855C249.392 109.855 260.592 106.023 267.392 102.079C267.409 101.841 267.368 101.601 267.273 101.382C267.179 101.162 267.033 100.968 266.848 100.815C261.028 103.776 255.045 106.404 248.928 108.687Z",
    fill: "url(#paint32_linear_300_160)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M248.928 108.687C248.368 108.895 249.392 109.855 249.392 109.855C249.392 109.855 260.592 106.023 267.392 102.079C267.409 101.841 267.368 101.601 267.273 101.382C267.179 101.162 267.033 100.968 266.848 100.815C261.028 103.776 255.045 106.404 248.928 108.687Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M257.168 75.6473C259.376 76.7673 261.448 77.9433 263.568 79.2473C264.6 79.9033 265.624 80.5673 266.64 81.2873C267.656 82.0073 268.664 82.7433 269.68 83.5753L270.056 83.8873L270.528 84.3193C270.809 84.571 271.076 84.838 271.328 85.1193C271.584 85.3993 271.8 85.6713 272.008 85.9193C272.216 86.1673 272.44 86.4633 272.624 86.7193C273.369 87.7478 274.058 88.816 274.688 89.9193C275.928 92.0588 276.998 94.2923 277.888 96.5993C278.053 97.0352 278.061 97.5146 277.912 97.9561C277.763 98.3975 277.466 98.7737 277.071 99.0207C276.676 99.2677 276.207 99.3703 275.745 99.311C275.283 99.2517 274.856 99.0341 274.536 98.6953L274.496 98.6473C272.896 96.9433 271.352 95.1513 269.8 93.4793C268.248 91.8073 266.672 90.1113 265.368 89.3673C263.552 88.2393 261.528 87.1113 259.52 86.0073L253.472 82.6473C252.534 82.1508 251.832 81.3021 251.52 80.2879C251.208 79.2737 251.312 78.1771 251.808 77.2393C252.304 76.3015 253.153 75.5993 254.167 75.2873C255.182 74.9752 256.278 75.0788 257.216 75.5753L257.168 75.6473Z",
    fill: "url(#paint33_linear_300_160)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M257.168 75.6473C259.376 76.7673 261.448 77.9433 263.568 79.2473C264.6 79.9033 265.624 80.5673 266.64 81.2873C267.656 82.0073 268.664 82.7433 269.68 83.5753L270.056 83.8873L270.528 84.3193C270.809 84.571 271.076 84.838 271.328 85.1193C271.584 85.3993 271.8 85.6713 272.008 85.9193C272.216 86.1673 272.44 86.4633 272.624 86.7193C273.369 87.7478 274.058 88.816 274.688 89.9193C275.928 92.0588 276.998 94.2923 277.888 96.5993C278.053 97.0352 278.061 97.5146 277.912 97.9561C277.763 98.3975 277.466 98.7737 277.071 99.0207C276.676 99.2677 276.207 99.3703 275.745 99.311C275.283 99.2517 274.856 99.0341 274.536 98.6953L274.496 98.6473C272.896 96.9433 271.352 95.1513 269.8 93.4793C268.248 91.8073 266.672 90.1113 265.368 89.3673C263.552 88.2393 261.528 87.1113 259.52 86.0073L253.472 82.6473C252.534 82.1508 251.832 81.3021 251.52 80.2879C251.208 79.2737 251.312 78.1771 251.808 77.2393C252.304 76.3015 253.153 75.5993 254.167 75.2873C255.182 74.9752 256.278 75.0788 257.216 75.5753L257.168 75.6473Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M279.784 100.592L279.104 98.8875C279.104 98.8875 278.728 96.7115 277.376 96.1035L273.376 96.7355L273.512 97.0875C273.88 97.8875 273.6 99.3515 273.24 100.52C272.88 101.688 273.488 101.84 274 101.608C274.288 101.48 274.568 100.96 274.872 100.408C275.021 100.686 275.19 100.953 275.376 101.208L276.36 102.56C276.566 102.84 276.87 103.032 277.211 103.097C277.552 103.162 277.906 103.096 278.2 102.912L279.288 102.216C279.543 102.041 279.731 101.786 279.821 101.49C279.911 101.195 279.898 100.878 279.784 100.592Z",
    fill: "url(#paint34_linear_300_160)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M279.784 100.592L279.104 98.8875C279.104 98.8875 278.728 96.7115 277.376 96.1035L273.376 96.7355L273.512 97.0875C273.88 97.8875 273.6 99.3515 273.24 100.52C272.88 101.688 273.488 101.84 274 101.608C274.288 101.48 274.568 100.96 274.872 100.408C275.021 100.686 275.19 100.953 275.376 101.208L276.36 102.56C276.566 102.84 276.87 103.032 277.211 103.097C277.552 103.162 277.906 103.096 278.2 102.912L279.288 102.216C279.543 102.041 279.731 101.786 279.821 101.49C279.911 101.195 279.898 100.878 279.784 100.592Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M253.792 84.8477L252.816 84.9277L246.824 99.3917C247.151 99.4152 247.481 99.3882 247.8 99.3117C247.8 99.3117 255.608 96.3997 257.968 95.3117C256.384 92.0397 253.792 84.8477 253.792 84.8477Z",
    fill: "url(#paint35_linear_300_160)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M242.856 88.6397C243.584 92.4207 244.936 96.0543 246.856 99.3917C249.784 98.3837 254.664 96.4797 257.032 95.3917C255.44 91.9797 254.028 88.4869 252.8 84.9277C250.296 85.0957 244.8 87.1997 242.856 88.6397Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M248.8 91.7675C248.683 92.1587 248.453 92.5064 248.138 92.7667C247.824 93.027 247.439 93.1881 247.033 93.2296C246.626 93.2711 246.217 93.1913 245.856 93.0001C245.495 92.8089 245.199 92.515 245.006 92.1555C244.812 91.7961 244.729 91.3872 244.768 90.9808C244.807 90.5743 244.965 90.1884 245.223 89.8719C245.481 89.5555 245.827 89.3227 246.217 89.203C246.608 89.0833 247.025 89.0821 247.416 89.1995C247.94 89.3568 248.38 89.7156 248.639 90.1971C248.899 90.6786 248.957 91.2434 248.8 91.7675Z",
    fill: "url(#paint36_linear_300_160)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M250.328 89.0153C250.297 89.1488 250.226 89.2698 250.125 89.3624C250.024 89.4549 249.897 89.5147 249.761 89.534C249.625 89.5532 249.487 89.5309 249.364 89.47C249.241 89.4092 249.14 89.3126 249.073 89.1929C249.006 89.0733 248.976 88.9362 248.989 88.7996C249.001 88.663 249.054 88.5334 249.142 88.4276C249.229 88.3219 249.346 88.245 249.478 88.2071C249.61 88.1693 249.75 88.1721 249.88 88.2153C250.042 88.2671 250.179 88.3785 250.262 88.527C250.345 88.6755 250.369 88.85 250.328 89.0153Z",
    fill: "url(#paint37_linear_300_160)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M252.12 88.3197C252.101 88.4125 252.063 88.5003 252.009 88.5776C251.954 88.6549 251.884 88.7199 251.802 88.7685C251.721 88.8171 251.631 88.8481 251.537 88.8597C251.443 88.8713 251.347 88.8631 251.257 88.8357C251.166 88.8083 251.082 88.7622 251.01 88.7005C250.939 88.6388 250.88 88.5628 250.84 88.4773C250.799 88.3918 250.777 88.2988 250.774 88.2041C250.771 88.1095 250.788 88.0153 250.824 87.9277C250.85 87.843 250.892 87.7642 250.948 87.6959C251.004 87.6275 251.073 87.5709 251.151 87.5293C251.229 87.4876 251.315 87.4618 251.403 87.4533C251.491 87.4448 251.579 87.4538 251.664 87.4797C251.835 87.5315 251.979 87.6488 252.065 87.806C252.15 87.9633 252.17 88.1478 252.12 88.3197Z",
    fill: "url(#paint38_linear_300_160)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.632 94.5517L247.232 97.4717L246.792 96.0157L254.184 93.0957L254.632 94.5517Z",
    fill: "url(#paint39_linear_300_160)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M213.808 205.736C213.791 210.394 213.341 215.041 212.464 219.616C211.52 223.728 210.053 226.736 208.064 228.64C207.137 229.56 206.037 230.286 204.827 230.776C203.617 231.267 202.322 231.511 201.016 231.496C196.904 231.496 193.765 229.253 191.6 224.768C191.22 223.962 190.896 223.131 190.632 222.28C186.059 226.208 181.801 230.487 177.896 235.08L173.648 240.088C175.934 242.405 178.572 244.346 181.464 245.84C186.445 248.416 192.984 249.707 201.08 249.712C202.504 249.712 203.88 249.672 205.216 249.592C210.114 242.345 214.167 234.561 217.296 226.392L229.176 195.416L213.808 205.736Z",
    fill: "black"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M106.712 248L120.712 262L159.912 225.064C146.4 219.904 120.128 234.552 106.712 248Z",
    fill: "#263238"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M155.536 296.801C151.064 292.321 141.536 282.801 141.536 282.801L178.472 243.601C183.6 257.081 168.952 283.377 155.536 296.801Z",
    fill: "#263238"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M209.12 208.56L224.392 179.112L194.944 194.4C185.485 199.306 176.752 205.498 168.992 212.8L118.792 260.056L143.456 284.72L190.712 234.52C198.018 226.759 204.213 218.022 209.12 208.56Z",
    fill: "url(#paint40_linear_300_160)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M209.12 208.56L224.392 179.112L194.944 194.4C185.485 199.306 176.752 205.498 168.992 212.8L118.792 260.056L143.456 284.72L190.712 234.52C198.018 226.759 204.213 218.022 209.12 208.56Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M177.76 236.064C183.46 236.064 188.08 231.443 188.08 225.744C188.08 220.044 183.46 215.424 177.76 215.424C172.06 215.424 167.44 220.044 167.44 225.744C167.44 231.443 172.06 236.064 177.76 236.064Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M177.76 232.376C181.423 232.376 184.392 229.407 184.392 225.744C184.392 222.082 181.423 219.112 177.76 219.112C174.097 219.112 171.128 222.082 171.128 225.744C171.128 229.407 174.097 232.376 177.76 232.376Z",
    fill: "url(#paint41_linear_300_160)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M151.8 275.857L127.648 251.705L147.424 233.097L170.408 256.089L151.8 275.857Z",
    fill: "url(#paint42_linear_300_160)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M112.176 270.097C94.096 271.561 88.104 283.137 86.056 298.521C85.016 306.369 84.552 314.313 77.968 318.905C77.572 319.174 77.2737 319.564 77.118 320.017C76.9624 320.47 76.9576 320.961 77.1044 321.417C77.2513 321.873 77.5418 322.269 77.9326 322.546C78.3234 322.822 78.7933 322.965 79.272 322.953C103.544 322.193 114.864 310.313 116.288 305.353C115.914 307.946 115.246 310.487 114.296 312.929C114.121 313.359 114.087 313.834 114.198 314.286C114.309 314.737 114.56 315.142 114.915 315.443C115.269 315.743 115.71 315.924 116.173 315.96C116.637 315.995 117.1 315.884 117.496 315.641C124.304 311.377 132.848 303.521 133.416 290.777C128.408 283.681 112.176 270.097 112.176 270.097Z",
    fill: "url(#paint43_linear_300_160)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M112.176 270.097C94.096 271.561 88.104 283.137 86.056 298.521C85.016 306.369 84.552 314.313 77.968 318.905C77.572 319.174 77.2737 319.564 77.118 320.017C76.9624 320.47 76.9576 320.961 77.1044 321.417C77.2513 321.873 77.5418 322.269 77.9326 322.546C78.3234 322.822 78.7933 322.965 79.272 322.953C103.544 322.193 114.864 310.313 116.288 305.353C115.914 307.946 115.246 310.487 114.296 312.929C114.121 313.359 114.087 313.834 114.198 314.286C114.309 314.737 114.56 315.142 114.915 315.443C115.269 315.743 115.71 315.924 116.173 315.96C116.637 315.995 117.1 315.884 117.496 315.641C124.304 311.377 132.848 303.521 133.416 290.777C128.408 283.681 112.176 270.097 112.176 270.097Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M136.224 296.24L107.264 267.28L122.688 263.944L139.56 280.816L136.224 296.24Z",
    fill: "url(#paint44_linear_300_160)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_300_160",
    x1: 111.488,
    y1: 150.264,
    x2: 111.488,
    y2: 248.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_300_160",
    x1: 201.139,
    y1: 150.248,
    x2: 201.139,
    y2: 249.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_300_160",
    x1: 290.756,
    y1: 150.264,
    x2: 290.756,
    y2: 248.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_300_160",
    x1: 159.304,
    y1: 115,
    x2: 159.304,
    y2: 117.992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_300_160",
    x1: 58.3759,
    y1: 171.848,
    x2: 58.3759,
    y2: 173.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_300_160",
    x1: 232.84,
    y1: 325.151,
    x2: 232.84,
    y2: 328.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_300_160",
    x1: 269.2,
    y1: 264.544,
    x2: 269.2,
    y2: 266.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_300_160",
    x1: 338.28,
    y1: 75.4395,
    x2: 338.28,
    y2: 77.5515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_300_160",
    x1: 137.144,
    y1: 54.1436,
    x2: 137.144,
    y2: 56.2556,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_300_160",
    x1: 222.16,
    y1: 108.495,
    x2: 222.16,
    y2: 110.607,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_300_160",
    x1: 112.984,
    y1: 75.5596,
    x2: 112.984,
    y2: 110.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_300_160",
    x1: 109.94,
    y1: 79.8633,
    x2: 109.94,
    y2: 110.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_300_160",
    x1: 103.6,
    y1: 82.8955,
    x2: 103.6,
    y2: 86.0955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_300_160",
    x1: 122.448,
    y1: 81.2959,
    x2: 122.448,
    y2: 84.4959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_300_160",
    x1: 118.224,
    y1: 91.6953,
    x2: 118.224,
    y2: 96.9433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_300_160",
    x1: 109.008,
    y1: 98.2959,
    x2: 109.008,
    y2: 105.304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_300_160",
    x1: 290.774,
    y1: 297.448,
    x2: 320.72,
    y2: 304.516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_300_160",
    x1: 308.389,
    y1: 288.416,
    x2: 308.389,
    y2: 316.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_300_160",
    x1: 307.383,
    y1: 296.004,
    x2: 307.383,
    y2: 314.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_300_160",
    x1: 252.386,
    y1: 95.7119,
    x2: 252.386,
    y2: 294.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_300_160",
    x1: 260.56,
    y1: 77.5996,
    x2: 260.56,
    y2: 106.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_300_160",
    x1: 263.022,
    y1: 103.928,
    x2: 263.022,
    y2: 161.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_300_160",
    x1: 270.032,
    y1: 146.336,
    x2: 270.032,
    y2: 153.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_300_160",
    x1: 276,
    y1: 150.392,
    x2: 276,
    y2: 154.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_300_160",
    x1: 233.998,
    y1: 81.1289,
    x2: 233.998,
    y2: 96.6808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_300_160",
    x1: 221.224,
    y1: 79.0479,
    x2: 221.224,
    y2: 86.0159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_300_160",
    x1: 253.546,
    y1: 76.0869,
    x2: 253.546,
    y2: 109.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_300_160",
    x1: 260.328,
    y1: 83.792,
    x2: 260.328,
    y2: 89.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_300_160",
    x1: 246.862,
    y1: 64.3408,
    x2: 246.862,
    y2: 81.1277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_300_160",
    x1: 278.305,
    y1: 101.76,
    x2: 278.305,
    y2: 143.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_300_160",
    x1: 294.172,
    y1: 129.592,
    x2: 294.172,
    y2: 138.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_300_160",
    x1: 300.124,
    y1: 130.512,
    x2: 300.124,
    y2: 133.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_300_160",
    x1: 258.078,
    y1: 100.815,
    x2: 258.078,
    y2: 109.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_300_160",
    x1: 264.68,
    y1: 75.1104,
    x2: 264.68,
    y2: 99.3274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_300_160",
    x1: 276.506,
    y1: 96.1035,
    x2: 276.506,
    y2: 103.122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_300_160",
    x1: 252.396,
    y1: 84.8477,
    x2: 252.396,
    y2: 99.3999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_300_160",
    x1: 246.823,
    y1: 89.1123,
    x2: 246.823,
    y2: 93.2403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_300_160",
    x1: 249.667,
    y1: 88.1807,
    x2: 249.667,
    y2: 89.5407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_300_160",
    x1: 251.46,
    y1: 87.4502,
    x2: 251.46,
    y2: 88.8648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_300_160",
    x1: 250.712,
    y1: 93.0957,
    x2: 250.712,
    y2: 97.4717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_300_160",
    x1: 171.592,
    y1: 179.112,
    x2: 171.592,
    y2: 284.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_300_160",
    x1: 177.76,
    y1: 219.112,
    x2: 177.76,
    y2: 232.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_300_160",
    x1: 149.028,
    y1: 233.097,
    x2: 149.028,
    y2: 275.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_300_160",
    x1: 105.207,
    y1: 270.097,
    x2: 105.207,
    y2: 322.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_300_160",
    x1: 123.412,
    y1: 263.944,
    x2: 123.412,
    y2: 296.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9E9FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056D2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404ErrorRafikiIllustration);
export default __webpack_public_path__ + "static/media/404 Error-Rafiki Illustration.1f5deafa080c0e09dc35a6fbfa608507.svg";
export { ForwardRef as ReactComponent };